import classNames from 'classnames';

import { CrossIcon, SmsAddOnIcon } from '../../atoms';
import type { PlanPriceBreakdown as PlanPriceBreakdownData } from '../CardSelect/types';

import './plan-price-breakdown.scss';

type Props = {
  breakdown: PlanPriceBreakdownData;
  onRemoveSms?: () => void;
};

export const PlanPriceBreakdown = ({ breakdown, onRemoveSms }: Props) => {
  const { rows, includedLabel, removeSmsLabel, removeSmsDataAttributes } = breakdown;

  if (includedLabel) {
    return (
      <div className="plan-price-breakdown plan-price-breakdown--included">
        <span className="plan-price-breakdown__included-badge">
          <SmsAddOnIcon className="plan-price-breakdown__sms-icon" />
          {includedLabel}
        </span>
      </div>
    );
  }

  if (!rows?.length) {
    return null;
  }

  return (
    <div className="plan-price-breakdown">
      <ul className="plan-price-breakdown__rows">
        {rows.map((row) => (
          <li
            key={row.id}
            className={classNames(
              'plan-price-breakdown__row',
              row.variant === 'sms' && 'plan-price-breakdown__row--sms'
            )}
          >
            <span className="plan-price-breakdown__label">
              {row.variant === 'sms' && <SmsAddOnIcon className="plan-price-breakdown__sms-icon" />}
              {row.label}
            </span>
            <span className="plan-price-breakdown__price">{row.price}</span>
          </li>
        ))}
      </ul>
      {removeSmsLabel && onRemoveSms ? (
        <div className="plan-price-breakdown__footer">
          <button
            type="button"
            className="plan-price-breakdown__remove"
            onClick={(event) => {
              event.stopPropagation();
              onRemoveSms();
            }}
            {...(removeSmsDataAttributes ?? {})}
          >
            <CrossIcon className="plan-price-breakdown__remove-icon" />
            {removeSmsLabel}
          </button>
        </div>
      ) : null}
    </div>
  );
};
